import React from "react";
import { Globe } from "lucide-react";
import NarrativeAssessmentCardBase from "./NarrativeAssessmentCardBase";

const MarketAnalysisNarrativeAssessmentViewer = ({ markdown = "" }) => (
  <NarrativeAssessmentCardBase
    markdown={markdown}
    Icon={Globe}
    subtitle="Market demand, positioning, and category context"
    badge="MARKET"
    theme={{
      cardBg: "#ecfeff",
      cardBorder: "#bae6fd",
      heroBg: "#dff7ff",
      heroBorder: "#7dd3fc",
      badgeBg: "rgba(6, 182, 212, 0.12)",
      badgeBorder: "#0891b2",
      iconColor: "#0e7490",
      dotColor: "#06b6d4",
    }}
  />
);

export default MarketAnalysisNarrativeAssessmentViewer;
